import React, { useState, useEffect } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import styles from './ProcreateSpace.module.css';

import Procreate1 from '../../images/lady-1.jpg';
import Procreate2 from '../../images/lady-2.jpg';
import Procreate3 from '../../images/lady-3.jpg';
import Procreate4 from '../../images/janmashtami.jpg';
import Procreate5 from '../../images/lady-4.jpg';
import Procreate6 from '../../images/shiva.jpg';
import Procreate9 from '../../images/lady-5.jpg';
import Procreate10 from '../../images/lady-13.jpg';
import Procreate11 from '../../images/lady-11.jpg';
import Procreate12 from '../../images/lady-14.jpg';
import Procreate13 from '../../images/lady-6.jpg';
import Procreate14 from '../../images/lady-15.jpg';
import Procreate15 from '../../images/man-2.jpg';
import Procreate16 from '../../images/man-5.jpg';
import Procreate17 from '../../images/man-3.jpg';
import Procreate7 from '../../images/theyyam.jpg';
import Procreate8 from '../../images/Mural_Art_2.jpg';

export default function CreativeSpace() {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mode, setMode] = useState('graphic');

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const images = [
    Procreate1, Procreate2, Procreate3,
    Procreate4, Procreate5, Procreate6,
    Procreate9, Procreate10,Procreate11,
    Procreate12, Procreate13,Procreate14,
    Procreate15, Procreate16,Procreate17,
    Procreate7, Procreate8,
  ];

  const openLightbox = (src) => {
    setSelectedImage(src);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setSelectedImage(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <div className={styles.pageWrapper}>
      <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} mode={mode} setMode={setMode} />

      <main className={styles.mainContainer}>
        {/* Background Orbs */}
        <div className={styles.backgroundEffects}>
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className={styles.floatingOrb}
              style={{
                width: `${Math.random() * 300 + 80}px`,
                height: `${Math.random() * 300 + 80}px`,
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                background: `radial-gradient(circle, ${
                  ['rgba(168,85,247,0.4)', 'rgba(236,72,153,0.4)', 'rgba(59,130,246,0.4)', 'rgba(34,211,238,0.4)'][i % 4]
                } 0%, transparent 70%)`,
                animationDuration: `${15 + Math.random() * 15}s`,
                animationDelay: `${Math.random() * 8}s`,
              }}
            />
          ))}
        </div>

        {/* Mouse Glow */}
        <div
          className={styles.mouseFollower}
          style={{
            transform: `translate(${mousePosition.x - 192}px, ${mousePosition.y - 192}px)`,
          }}
        />

        <div className={styles.contentWrapper}>
          {/* Hero */}
          <div className={styles.headerSection}>
            <h1 className={styles.title}>
              Creative Space
              <div className={styles.titleDecoration} />
            </h1>
            <div className={styles.description}>
              <p>
                Images crafted using Procreate, an Apple product software, showcasing artistic prowess. Further enhancements and corrections applied through Photoshop, refining details and ensuring quality. Seamlessly blending digital artistry with advanced editing techniques for captivating visual content.
              </p>
            </div>
          </div>

          {/* First 6 - 3x2 Grid */}
          <div className={styles.imageGrid}>
            {images.slice(0, 15).map((src, i) => (
              <div
                key={i}
                className={styles.card}
                style={{ animationDelay: `${0.8 + i * 0.1}s` }}
                onClick={() => openLightbox(src)}
              >
                <img src={src} alt={`Artwork ${i + 1}`} />
              </div>
            ))}
          </div>

          {/* Last 2 - One Full Row */}
          <div className={styles.lastRow}>
            {images.slice(15).map((src, i) => (
              <div
                key={i + 6}
                className={styles.card}
                style={{ animationDelay: `${1.6 + i * 0.2}s` }}
                onClick={() => openLightbox(src)}
              >
                <img src={src} alt={`Artwork ${i + 7}`} />
              </div>
            ))}
          </div>
        </div>

        {/* Lightbox */}
        {lightboxOpen && (
          <div className={styles.lightboxOverlay} onClick={closeLightbox}>
            <img
              src={selectedImage}
              alt="Enlarged view"
              className={styles.lightboxImage}
              onClick={(e) => e.stopPropagation()}
            />
            <div className={styles.closeButton} onClick={closeLightbox}>
              ×
            </div>
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
}